import { jsx as _jsx } from "react/jsx-runtime";
import TutorPage from "./TutorPage";
export default function AdditionPage() {
    return _jsx(TutorPage, { initialTopic: "Addition", lockTopic: true });
}
